<template>
  <div class="News-detail">
    <div class="product-Item">
    <div class="introduction_r">
      <div class="introduction_nameBox">
        <el-page-header @back="goBack" :content="title"></el-page-header>
      </div>
      <div class="introduction_cont" v-html="content"></div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      pressId:'',
      title:'',
      content:""
    }
  },
  created(){
    this.pressId = this.$route.query.pressId
    this.title = this.$route.query.title
  },
  mounted(){
    this.getContentInfo()
  },
  methods:{
    goBack() {
      // history.go(-1)
      this.$router.go(-1);//返回上一层
    },
    getContentInfo() {
      let url = "/pressController/front/searchPressInfo";
      this.$axios
        .get(url, {
          params: {
            pressId: this.pressId,
          },
        })
        .then((res) => {
          console.log(res);
          const regex = new RegExp('<img', 'gi')
          this.content = res.data.data.content.replace(regex,`<img style="max-width: 100%; height: auto"`);
        });
    }
  }
}
</script>

<style scoped lang="less">
.product-Item {
  width: 1200px;
  margin: 15px auto;
  .introduction_r {
    // width: calc(1200px - 304px);
    .introduction_nameBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 0;
      // margin-bottom: 30px;
      border-bottom: 1px solid #e6e8ed;
      .introduction_name {
        font-size: 30px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #333333;
      }
      .inputBox {
        width: 360px;
        height: 36px;
        // background: #FFFFFF;
        border-radius: 4px;
        // border: 1px solid #1373CF;
      }
    }
    .introduction_cont {
      padding: 20px 0;
      min-height: 500px;
    }
  }
}
</style>